<script>
import Datepicker from 'vuejs-datepicker'
import * as lang from 'vuejs-datepicker/src/locale'
import Timepicker from '../lib/time-picker.vue'

export default {
  components: { Datepicker, Timepicker },
  data() {
    return {
      appointmentDate: new Date(),
      appointmentTime: '10:00',
      appointmentSubject: 'Kennenlernen',
      dateFormat: 'yyyy-MM-dd',
      languages: lang
    }
  },
  methods: {
    submitAppointment() {
      if (this.appointmentDate && this.appointmentTime && this.appointmentSubject) {
        this.$emit('submit', {
            date: this.appointmentDate.toISOString().slice(0, 10),
            time: this.appointmentTime,
            subject: this.appointmentSubject,
        })
      } else {
        alert('Bitte fülle alle Felder aus.')
      }
    }
  }
}
</script>

<template>
  <form>
    <div class="mb-3">
      <datepicker :inline="true" :language="languages['de']" placeholder="Datum" v-model="appointmentDate"
      :format="dateFormat" />
    </div>

    <div class="form-group mb-3">
      <timepicker v-model="appointmentTime" class="form-control"/>
    </div>

    <div class="form-group mb-3">
      <input 
        type="text" 
        v-model="appointmentSubject" 
        class="form-control" 
        placeholder="Thema"
      />
    </div>

    <button @click.prevent="submitAppointment" class="btn btn-primary">
       Weiter ...
    </button>

  </form>
</template>
